import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import { Alert, Autocomplete, Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";

const UserRateUpdateServicesSelect = ({ checkedService, setCheckedService }) => {
  const { t } = useTranslation("otherInterface");

  const [rateBase, setRateBase] = useState(null);
  const [fetchingServices, setFetchingServices] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get(`/api/rate-update-services/` + checkedService.currency.asset, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setRateBase(response.data);
        setFetchingServices(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (fetchingServices) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (!rateBase || Object.keys(rateBase).length === 0) {
    return <Alert severity="warning">{t("services.empty")}</Alert>;
  }

  let currentService = rateBase.filter(item => item.id === checkedService.id);

  return (
    <>
      <FormControl>
        <Autocomplete
          options={rateBase || []}
          value={currentService[0] || null}
          onChange={(event, checkedService) => setCheckedService(checkedService)}
          getOptionLabel={(option) => option.service.name}
          renderInput={(params) => (
            <TextField {...params} label={t("services.rateBaseService")} />
          )}
          blurOnSelect
          disableClearable
        />
      </FormControl>
    </>
  );
};

export default UserRateUpdateServicesSelect;